import { render, staticRenderFns } from "./wjPatrolStandardList.vue?vue&type=template&id=4328f498&"
import script from "./wjPatrolStandardList.vue?vue&type=script&lang=js&"
export * from "./wjPatrolStandardList.vue?vue&type=script&lang=js&"
import style0 from "./wjPatrolStandardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports